import React from 'react'
import ReactDom from 'react-dom'
import coact from 'coact'

import models from './models'
import views from './views'

import UploadTemplate from 'components/UploadTemplate'
import IncomeStatement from 'components/IncomeStatement'
import ImportCsv from 'components/ImportCsv'
import ImportProducts from 'components/ImportProducts'
import RagicSyncer from 'components/RagicSyncer'
import Statement from 'components/Statement'

import productsAEditor from 'components/products/productsA'
import productsBEditor from 'components/products/productsB'
import productsCEditor from 'components/products/productsC'
import productsDEditor from 'components/products/productsD'
import productsEEditor from 'components/products/productsE'
import productsFEditor from 'components/products/productsF'

const config = {}

config.views = views

config.ui = {}

config.models = models

config.ui.navbar = {
  title: '中天眼鏡',
}

config.routes = [
  {
    path: '/upload/template',
    component: UploadTemplate,
  },
  {
    path: '/statement',
    component: Statement,
  },
  {
    path: '/export/incomeStatement',
    component: IncomeStatement,
  },
  {
    path: '/import/importCsv',
    component: ImportCsv,
  },
  {
    path: '/import/importProducts',
    component: ImportProducts,
  },
  {
    path: '/route/syncRagicer',
    component: RagicSyncer,
  },
  {
    path: '/edit/productsA/:id',
    component: productsAEditor,
  },
  {
    path: '/edit/productsB/:id',
    component: productsBEditor,
  },
  {
    path: '/edit/productsC/:id',
    component: productsCEditor,
  },
  {
    path: '/edit/productsD/:id',
    component: productsDEditor,
  },
  {
    path: '/edit/productsE/:id',
    component: productsEEditor,
  },
  {
    path: '/edit/productsF/:id',
    component: productsFEditor,
  },
]

const App = coact(config)

window.React = React
ReactDom.render(
  React.createElement(App),
  document.getElementById(config.mountDomId || 'app')
)



// WEBPACK FOOTER //
// ./src/client.js